import { FilterNode } from './models/filter-node'

export class FilterSelectionInterpreterUtility {
  private static getObjectEnteriesValue(obj): any[] {
    const keys: string[] = Object.keys(obj),
      resArray = []
    keys.forEach((keyElement) => {
      resArray.push(obj[keyElement])
    })
    return resArray
  }
  private static getData(jsonObj): any {
    return {
      id: jsonObj.id,
      ruleName: jsonObj.rule,
      isSelected: jsonObj.value,
      objRef: jsonObj,
    }
  }

  // eslint-disable-next-line complexity,max-statements
  static generateTreeStruct(jsonObj: any): FilterNode[] {
    let node: FilterNode, nodeAryTemp: FilterNode[], nodeAry: FilterNode[]
    if (jsonObj && Array.isArray(jsonObj)) {
      nodeAry = []
      jsonObj.forEach((jsonElement: any) => {
        nodeAryTemp = this.generateTreeStruct(jsonElement)
        nodeAry.push(nodeAryTemp[0])
      })
      return nodeAry
    } else {
      if (jsonObj.rule) {
        if (jsonObj.level2) {
          node = new FilterNode(this.getData(jsonObj))
          node.addChildren(this.generateTreeStruct(jsonObj.level2))
          return [node]
        } else {
          return [new FilterNode(this.getData(jsonObj))]
        }
      } else {
        nodeAry = []
        this.getObjectEnteriesValue(jsonObj).forEach((value) => {
          nodeAry.push(this.generateTreeStruct(value)[0])
        })
      }
    }
    return nodeAry
  }

  static traverseTree(
    startNode: FilterNode,
    callBack: (arg0: FilterNode) => void,
  ) {
    callBack(startNode)
    const childNodeAry = startNode.getChildren()
    if (childNodeAry) {
      childNodeAry.forEach((childNode) => {
        this.traverseTree(childNode, callBack)
      })
    }
  }
}
